import { Box, BoxProps } from '@material-ui/core';
import React from 'react';

import MainLogo from '../assets/logo1.svg';
import AlternativeLogo from '../assets/logo2.svg';

interface LogoProps extends BoxProps {
  alternative?: boolean;
}

const Logo: React.FC<LogoProps> = (props) => {
  const { alternative } = props;

  return <Box {...props}>
    <img src={ alternative ? AlternativeLogo : MainLogo } />
  </Box>;
};

export default Logo;
